"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2331],{

/***/ 22331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74237);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93359);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19599);
/* harmony import */ var components_common_Category_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24636);
/* harmony import */ var provider_Store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16926);
/* harmony import */ var screen_Stores_Skeleton_WalletLoading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39359);
/* harmony import */ var screen_Stores_Skeleton_WidgetsLoading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22519);
/* harmony import */ var utility_booleanParser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58256);









var Widgets = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6404).then(__webpack_require__.bind(__webpack_require__, 16404));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16404)
            ];
        }
    },
    suspense: true
});
var Wallet = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 4860).then(__webpack_require__.bind(__webpack_require__, 64860));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64860)
            ];
        }
    },
    suspense: true
});
var Categories = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9619), __webpack_require__.e(4053)]).then(__webpack_require__.bind(__webpack_require__, 65857));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65857)
            ];
        }
    },
    suspense: true
});
var Content = function() {
    var state = react__WEBPACK_IMPORTED_MODULE_2__.useContext(provider_Store__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).state;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        container: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                mt: "2.4rem",
                width: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Category_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Categories, {})
                    })
                })
            }),
            !(0,utility_booleanParser__WEBPACK_IMPORTED_MODULE_9__/* .booleanParser */ .P)(state.app_keepa) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                mt: "4rem",
                width: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(screen_Stores_Skeleton_WalletLoading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wallet, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                mt: (0,utility_booleanParser__WEBPACK_IMPORTED_MODULE_9__/* .booleanParser */ .P)(state.app_keepa) ? "-2rem" : "5.7rem",
                width: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(screen_Stores_Skeleton_WidgetsLoading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Widgets, {})
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content);


/***/ })

}]);